import { createReducer } from 'redux-orm';

import orm from '../orm';

export default createReducer(orm);
